import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import Telemetry, * as TelemetryActions from 'redux/Telemetry';
import Notifications from 'redux/Notifications';
import { BucketPeriods, BucketUnits } from 'utils/ReadingsHelpers';

const useTelemetry = () => {
  const [lastActiveFieldId, setLastActiveFieldId] = useState('');
  const [lastTimePeriod, setLastTimePeriod] = useState({});

  const dispatch = useDispatch();
  const telemetry = useSelector(Telemetry.getAllTelemetry);
  const isFetching = useSelector(Telemetry.getIsFetching);

  const telemetryPeriod = useSelector(Telemetry.getTelemetryPeriod);
  const telemetryAverage = useSelector(Telemetry.getAverage);
  const fieldTelemetry = useSelector(Telemetry.getFieldTelemetry);
  const deviceTelemetry = useSelector(Telemetry.getDeviceTelemetry);

  const activeFieldTelemetry = useSelector(Telemetry.getActiveFieldTelemetry);
  const selectedDeviceTelemetry = useSelector(Telemetry.getActiveDeviceTelemetry);

  const telemetryAverages = useSelector(Telemetry.getAverages);

  const fetchTelemetry = (layerIds, days, reading, bucket_period, bucket_unit, include_today) => {
    if (!isFetching) {
      dispatch(Telemetry.requestTelemetry());
      return dispatch(
        Telemetry.fetchLayerAvgTelemetry(layerIds, days, reading, bucket_period, bucket_unit, include_today)
      ).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const exportTelemetry = (org, field, device, time) => {
    if (!isFetching) {
      let bucket_period = BucketPeriods.One;
      let bucket_unit = BucketUnits.Days;
      if (time === 1) {
        bucket_period = BucketPeriods.Four;
        bucket_unit = BucketUnits.Hours;
      } else if (time === 7) {
        bucket_period = BucketPeriods.Four;
        bucket_unit = BucketUnits.Hours;
      } else if (time === 30) {
        bucket_period = BucketPeriods.Four;
        bucket_unit = BucketUnits.Hours;
      }
      dispatch(Telemetry.requestTelemetry());
      return new Promise((resolve) => {
        dispatch(
          Telemetry.fetchLayerAvgTelemetry(
            { hw_address: device?.hw_address, field_id: field?.id, organization_id: org?.id },
            time,
            undefined,
            bucket_period,
            bucket_unit,
            true
          )
        ).then((resp) => {
          dispatch(Telemetry.endRequestTelemetry());
          resolve(resp);
        });
      }).catch((err) => {
        dispatch(Telemetry.endRequestTelemetry());
        dispatch(Notifications.setError(err));
      });
    }
  };

  const fetchAvgFieldDevicesTel = (
    devicesHWAddresses,
    days,
    reading,
    bucket_period,
    bucket_unit,
    field_id,
    include_today
  ) => {
    let noConflict = true;
    devicesHWAddresses.forEach((device) => {
      if (isFetching[device]) {
        noConflict = false;
      }
    });
    if (noConflict) {
      return dispatch(
        Telemetry.fetchDevicesAvgTelemetry(
          devicesHWAddresses,
          days,
          reading,
          bucket_period,
          bucket_unit,
          field_id,
          include_today
        )
      ).catch((err) => {
        dispatch(Notifications.setError(err));
      });
    }
  };

  const reqTelemetry = (layerIds, telemetryPeriod, bucket) => {
    let { period, unit, include_today } = bucket;

    if (!period) {
      period = BucketPeriods.Seven;
    }
    if (!unit) {
      unit = BucketUnits.Days;
    }
    if (!include_today) {
      include_today = false;
    }

    const days = telemetryPeriod;
    fetchTelemetry(layerIds, days, undefined, period, unit, include_today);
  };

  const reqDevicesAvgTel = (field, devices, telemetryPeriod, bucket) => {
    const days = telemetryPeriod;
    const fieldId = field.id;

    if (
      fieldId !== lastActiveFieldId ||
      !!devices ||
      (lastTimePeriod.period !== bucket.period && lastTimePeriod.unit !== bucket.unit)
    ) {
      setLastTimePeriod(bucket);
      setLastActiveFieldId(fieldId);

      dispatch(Telemetry.requestAvgTelemetry(devices));
      fetchAvgFieldDevicesTel(devices, days, undefined, bucket.period, bucket.unit, fieldId, bucket.include_today);
    }
  };

  const setTelemetryPeriod = (period) => {
    dispatch(TelemetryActions.setTelemetryPeriod(period));
  };

  return {
    telemetry,
    isFetching,
    // currentTelemetry,
    telemetryPeriod,
    telemetryAverage,
    telemetryAverages,
    fieldTelemetry,
    deviceTelemetry,
    activeFieldTelemetry,
    setTelemetryPeriod,
    selectedDeviceTelemetry,
    fetchTelemetry,
    reqDevicesAvgTel,
    reqTelemetry,
    exportTelemetry,
  };
};

export default useTelemetry;
